import { Component, Input } from '@angular/core';
import { AlertService } from '@services/helpers/alert/alert.service';
import { Alert, AlertType } from '@models/app/alert/Alert';
import { animate, style, transition, trigger } from '@angular/animations';
import { IconComponent } from '../icon/icon.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    animations: [
        trigger('fade', [
            transition('void => *', [
                style({ opacity: 0 }),
                animate(200, style({ opacity: 1 })),
            ]),
            transition('* => void', [animate(200, style({ opacity: 0 }))]),
        ]),
    ],
    standalone: true,
    imports: [IconComponent, AsyncPipe]
})
export class AlertComponent {
  @Input() fade = true;
  AlertType = AlertType;

  constructor(public alertService: AlertService) {}

  removeAlert(alert: Alert): void {
    this.alertService.removeAlert(alert)
  }

  cssClass(alert: Alert): string {
    if (!alert) {
      return null;
    }

    const classes = [];

    const alertTypeClass = {
      [AlertType.Success]: 'alert-success',
      [AlertType.Error]: 'alert-danger',
      [AlertType.Info]: 'alert-info',
      [AlertType.Warning]: 'alert-warning',
      [AlertType.Live]: 'alert-info',
    };

    classes.push(alertTypeClass[alert.type]);

    if (alert.fade) {
      classes.push('fade');
    }

    return classes.join(' ');
  }
}
